export default {
    ALTA_COMPLEXIDADE: 3,
}